// extracted by mini-css-extract-plugin
export default {"contact-box":"ContactBox_contact-box__lS8S0"};